import React from 'react';
import { RoutePermittedRole } from '../../constants/AppEnums';
const Category = React.lazy(() => import('../../../modules/category'));
const CreateCategory = React.lazy(() => import('../../../modules/category/Create'));
const UpdateCategory = React.lazy(() => import('../../../modules/category/Update'));
export const categoryRouteConfig = [
  {
    permittedRole: RoutePermittedRole.Admin,
    path: '/category',
    element: <Category />,
  },
  {
    permittedRole: RoutePermittedRole.Admin,
    path: '/category/create',
    element: <CreateCategory />,
  },
  {
    permittedRole: RoutePermittedRole.Admin,
    path: '/category/:id/update',
    element: <UpdateCategory />,
  }
];
